export default "__VITE_ASSET__By53fd9o__"